import Utils from 'general/utils/Utils'
import './style.scss'

function AmbiguousPicker({ candidates = [], onPick }) {
  return (
    <div className="AmbiguousPicker mt-5">
      <p className="ap-title">
        Mã tra cứu khớp nhiều hóa đơn/vé. Vui lòng chọn đúng chứng từ của bạn:
      </p>
      <div className="ap-list">
        {candidates.map((c, i) => (
          <button key={i} className="ap-item" onClick={() => onPick(c)}>
            <div className="ap-row">
              <span className="ap-label">{c.type === 'ticket' ? 'Vé' : 'Hóa đơn'}</span>
              <span className="ap-strong">
                {c.serial} — {c.no}
              </span>
            </div>
            <div className="ap-row">
              <span>{c.sellerName}</span>
              <span>
                {typeof c.total === 'number' ? Utils.formatNumber(c.total) : c.total}{' '}
                {c.currency || 'VND'}
              </span>
            </div>
            {c.date && (
              <div className="ap-date">{new Date(c.date).toLocaleDateString('vi-VN')}</div>
            )}
          </button>
        ))}
      </div>
    </div>
  )
}

export default AmbiguousPicker
